var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"appRoot"}},[(!_vm.$route.meta.public)?[_c('v-app',[_c('router-view')],1)]:[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }